"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = void 0;
/**
 * An Error which is thrown when an API returns an error.
 *
 * @remarks
 * The `status` property provides the original HTTP status code. However, the same `status` can regroup different
 * distinct errors cause. To help distinguish between different causes, the `name` attribute contains the name of the
 * exceptions which occurred.
 *
 * @public
 */
class ClientError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = message;
    }
}
exports.ClientError = ClientError;
//# sourceMappingURL=Errors.js.map